import _toConsumableArray from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "section has-text-centered"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, _toConsumableArray(_cache[0] || (_cache[0] = [_createElementVNode("h1", {
    class: "title"
  }, "404 - Not found", -1), _createElementVNode("h2", {
    class: "subtitle"
  }, [_createTextVNode(" There is nothing here. Please Check the URL and try again. "), _createElementVNode("br"), _createTextVNode(" Hibás címre érkeztél. Kérjük ellenőrizd, hogy jól írtad-e be! ")], -1), _createElementVNode("span", {
    class: "icon is-large"
  }, [_createElementVNode("i", {
    class: "fas fa-3x fa-drafting-compass"
  })], -1), _createElementVNode("br", null, null, -1)])));
}